import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * 轻提示：只需要「说一句话」的场景，不值得引第三方 toast 库。
 * 返回 [当前文案, 显示函数]，显示后 2.2 秒自动消失。
 */
export function useToast() {
  const [message, setMessage] = useState('');
  const timerRef = useRef(null);

  const show = useCallback((text) => {
    if (!text) return;
    setMessage(text);
    window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => setMessage(''), 2200);
  }, []);

  useEffect(() => () => window.clearTimeout(timerRef.current), []);

  return [message, show];
}

export default function Toast({ message }) {
  if (!message) return null;
  return (
    <div className="toast" role="status" aria-live="polite">
      {message}
    </div>
  );
}
